import styled from '@xstyled/styled-components';
import React from 'react';
import { t } from 'ttag';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '../state';
import BackIcon from './assets/back.svg';
import { OnboardingStages, useOnboardingStore } from './Store';

const selector = (s: TrainingState) =>
  select(s, 'disclaimer', 'onboarding', 'shouldDisplayCourseDurationCard');

const Button = styled.button`
  border: none;
  background: transparent;
  position: fixed;
  top: 15px;
  left: 15px;
  border-radius: 4px;

  &:focus-visible {
    outline: 2px solid var(--color-focus-ring);
    outline-offset: 2px;
  }
`;

export const BackButton = () => {
  const { stage, previous, goTo } = useOnboardingStore(
    ({ stage, previous, goTo }) => ({ stage, previous, goTo })
  );
  const { disclaimer, onboarding, shouldDisplayCourseDurationCard } =
    useTrainingStore(selector);

  if (stage < 2) return null;

  const currentStage = stage;

  const goToWithCourseDuration = (nextStage: OnboardingStages) => {
    if (currentStage === OnboardingStages.CourseDuration)
      return goTo(nextStage);

    shouldDisplayCourseDurationCard
      ? goTo(OnboardingStages.CourseDuration)
      : goTo(nextStage);
  };

  const previousWithCourseDuration = () => {
    if (currentStage === OnboardingStages.CourseDuration)
      return onboarding
        ? goTo(OnboardingStages.Username)
        : goTo(OnboardingStages.LanguageSelection);
    if (currentStage === OnboardingStages.PassFail && !disclaimer)
      return goToWithCourseDuration(OnboardingStages.Username);
    if (currentStage === OnboardingStages.Disclaimer)
      return goToWithCourseDuration(OnboardingStages.Username);

    previous();
  };

  const goBack = () => {
    if (disclaimer && !onboarding) {
      goToWithCourseDuration(OnboardingStages.LanguageSelection);
    } else {
      stage == OnboardingStages.Autosaving && !disclaimer
        ? goToWithCourseDuration(OnboardingStages.Username)
        : previousWithCourseDuration();
    }
  };

  return (
    <Button
      onClick={goBack}
      title={t`Back to previous step`}
      data-test-id="back-button"
    >
      <BackIcon />
    </Button>
  );
};
